import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getThousandComma } from "../../../Api/ApiCommon";
import LineBtn from "../../../components/Button/LineBtn";
import LineBox from "../../../components/DefaultStyles/LineBox";
import Loader from "../../../components/DefaultStyles/Loader";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import ManageFaqButtons from "../../../components/pages/Manage/ManageFaq/ManageFaqButtons";
import ManageFaqFilter from "../../../components/pages/Manage/ManageFaq/ManageFaqFilter";
import Pagination from "../../../components/Table/Pagination";
import Table, {
  TableBody,
  TableBodyItem,
} from "../../../components/Table/Table";
import { useApi } from "../../../hooks/useApi";
import { TotalCount } from "../../Users/UserInfo";

interface IFaq {
  id: string;
  admin: string;
  category: string;
  content: string;
  ispublic: number;
  tag: string;
  title: string;
  updatedate: string;
  viewcount: number;
}

export default function ManageFaq() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [faqFilter, setFaqFilter] = useState({
    category: 0,
    keyword: "",
    orderByViewCount: 0,
  });

  const faqTableHeader = [
    "NO.",
    "카테고리",
    "제목",
    "태그",
    "작성자",
    "최종 작성일시",
    "조회수",
    "상세",
  ];

  const { response, loading, error } = useApi({
    method: "get",
    url:
      `FAQ?page=${page}&size=10` +
      `&orderBy=${faqFilter?.orderByViewCount > 0 ? "viewcount" : "id"}` +
      (faqFilter?.category > 0 ? `&category=${faqFilter?.category}` : ``) +
      (faqFilter?.keyword !== "" ? `&keyword=${faqFilter?.keyword}` : ``),
  });

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "자주 묻는 질문 조회에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <PageTitle title="자주 묻는 질문 관리" />

      <ManageFaqButtons />

      <ManageFaqFilter
        setSearchValue={setSearchValue}
        faqFilter={faqFilter}
        setFaqFilter={setFaqFilter}
        setPage={setPage}
      />

      <LineBox>
        <Table tableHeadData={faqTableHeader} tableMinWidth={880}>
          <>
            {response?.data?.items?.map((d: IFaq, index: number) => {
              return (
                <TableBody key={index}>
                  {/* NO. */}
                  <TableBodyItem>{d?.id} </TableBodyItem>

                  {/* 카테고리 */}
                  <TableBodyItem isKeepAll={true}>{d?.category}</TableBodyItem>

                  {/* 제목 */}
                  <TableBodyItem isKeepAll={true}>{d?.title}</TableBodyItem>

                  {/* 태그 */}
                  <TableBodyItem>{d?.tag}</TableBodyItem>

                  {/* 작성자 */}
                  <TableBodyItem>{d?.admin}</TableBodyItem>

                  {/* 최종 작성일시 */}
                  <TableBodyItem isKeepAll={true}>
                    {d?.updatedate}
                  </TableBodyItem>

                  {/* 조회수 */}
                  <TableBodyItem>
                    {getThousandComma(d?.viewcount)}
                  </TableBodyItem>

                  {/* 상세 */}
                  <TableBodyItem>
                    <LineBtn
                      btnText="상세"
                      btnClickEvent={() =>
                        navigate(`/linkid-manage/faq/${d?.id}`)
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +(response?.data?.totalCount ?? 0) : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
